module.exports = require("buffer");